import { render } from "./DefaultCard.vue?vue&type=template&id=6242a831"
import script from "./DefaultCard.vue?vue&type=script&lang=js"
export * from "./DefaultCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__